module.exports = __webpack_public_path__ + "img/p8.2b4d479c.png";